<template>
  <div class="catalogueMain">
    <div class="search">
      <input type="text" @change="search" v-model="searchContent" placeholder="Search Product Categories"/>
      <button @click="search">Search</button></div>
      <el-scrollbar class="catalogueContent">
        <ul :v-if="sortData.length">
          <li :class="active==''?'active':''" @click="chooseSortAll">All</li>
          <li :class="active==item.id?'active':''" v-for="(item,index) in list" :key="index" @click="chooseSort(item)"><span style="display:none;">{{index>8?index+1:"0"+(index+1)}}</span> {{item.class_name_en}}</li>
        </ul>
      </el-scrollbar>
    </div>
</template>

<script>
export default {
  props:{
    sortData:Array
  },
  data(){
    return {
      loadMore:'',
      active:'',
      list:[],
      searchContent:""
    }
  },
  mounted() {
    if (sessionStorage.getItem('goodsData')) {
      let goodsData = JSON.parse(sessionStorage.getItem('goodsData'))
      this.active = goodsData.choose
    }
 },
 methods:{
   chooseSort(data){
     this.active = data.id
     this.$emit("chooseSort",data)
   },
   chooseSortAll(){
     this.active = ""
     this.$emit("chooseSort",{id:""})
     this.list = this.sortData
   },
   search(){
     this.list = this.sortData.filter(item=>item.class_name_cn.indexOf(this.searchContent)>=0)
   }
 },
 watch:{
   sortData(){
     this.list = this.sortData
   }
 }
}
</script>

<style scoped>
  .search{
    text-align: center;
    padding: 14px 0;
    border-bottom: 1px solid #aaa;
  }
  .search >input{
    width: 80%;
    height: 30px;
    /* border-radius: 6px; */
    border: 1px solid #dcdfe6;
    padding: 10px;
    vertical-align: middle;
  }
  .search > button{
    width: 16%;
    border: 1px solid #dcdfe6;
    background-color: #f08300;
    color: white;
    height: 30px;
    border-left: none;
    outline: none;
    cursor: pointer;
    vertical-align: middle;
    transition:all .5s;
    /* font-family: 'microsoft yahei'; */
    font-size: 14px;
  }
  .search > button:hover{
    background-color: #f08300;
  }

  .el-scrollbar__bar{
    opacity: 1;
  }
  .el-scrollbar:active>.el-scrollbar__bar,
  .el-scrollbar:focus>.el-scrollbar__bar, 
  .el-scrollbar:hover>.el-scrollbar__bar{
    opacity: 1;
    transform: none;
  }
  .el-scrollbar__bar.is-vertical{
    width: 20px;
    top:0;
    right: 0;
    background: #E5E5E5;
    border-radius: 0px;
  }
  .el-scrollbar__thumb{
    margin-top: 10px;
    background-color: #008ba0;
  }
  .el-scrollbar__thumb:hover{
    background-color: #008ba0;
  }
  .catalogueMain{
    height: 496px;
    background-color: white;
    /* display: flex; */
    overflow: hidden;
  }
  .catalogueContent{
    width: 300px;
    height: calc(100% - 59px);
  }
  .catalogueContent .el-scrollbar__wrap{
    overflow: auto;
  }
  .catalogueContent li{
    /* padding-left: 20px; */
    padding: 6px 20px 6px 10px;
    line-height: 20px;
    flex-wrap: nowrap;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
    /* font-family: 'FjallaOne-Regular'; */
  }
  .catalogueContent li span{
    letter-spacing: 0;
  }
  .catalogueContent .active,
  .catalogueContent li:hover{
    background-color: #008baf;
    color: white;
  }
  .scrollArticle{
    height: 100%;
    width: 13px;
    background-color: #e5e5e5;
  }
  .scrillBar{
    height: 49px;
    width: 13px;
    background-color: #008baf;
  }

  @media (min-width: 768px) and (max-width: 900px) {
    .catalogueContent{
      width: 100%;
    }
    .catalogueContent li{
      /* padding: 6px 10px; */
      font-size: 12px;
      line-height: 16px;
    }
  }
</style>